import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';

export function EmailVerificationBanner() {
  const { currentUser, emailVerified, resendVerificationEmail, refreshUser } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState('');

  if (!currentUser || emailVerified) {
    return null;
  }

  const handleResend = async () => {
    setSending(true);
    setError('');
    try {
      await resendVerificationEmail();
      setSent(true);
      setTimeout(() => setSent(false), 5000);
    } catch (err: any) {
      setError(err.message || 'Failed to send verification email');
    } finally {
      setSending(false);
    }
  };

  const handleCheckVerification = async () => {
    setChecking(true);
    setError('');
    try {
      await refreshUser();
    } catch (err: any) {
      setError(err.message || 'Failed to check verification status');
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="verification-banner" style={{ marginTop: '12px' }}>
      <span style={{ flex: 1 }}>
        ⚠ Email not verified — check your inbox for a verification link
      </span>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <button
          onClick={handleCheckVerification}
          disabled={checking}
          className="action-btn"
          style={{ minWidth: 'auto', padding: '4px 12px', fontSize: '9px' }}
        >
          {checking ? 'Checking…' : "I've Verified"}
        </button>
        <button
          onClick={handleResend}
          disabled={sending || sent}
          className="action-btn secondary"
          style={{ minWidth: 'auto', padding: '4px 12px', fontSize: '9px' }}
        >
          {sent ? 'Sent' : sending ? 'Sending…' : 'Resend Email'}
        </button>
      </div>
      {error && (
        <div style={{ width: '100%', color: 'var(--danger)', fontSize: '9px', marginTop: '4px' }}>
          Error: {error}
        </div>
      )}
    </div>
  );
}
